export const TEST_CONFIG = 'test_config'
export const TEST_CONFIGURATIONS_NAMES = 'test_configuration_names'
